var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.7933L13.1659 28.6274C12.9175 28.8758 12.6186 29 12.2692 29C11.9199 29 11.621 28.8758 11.3726 28.6274C11.1242 28.379 11 28.0801 11 27.7307C11 27.3814 11.1242 27.0825 11.3726 26.8341L18.2067 20L11.3726 13.1659C11.1242 12.9175 11 12.6186 11 12.2692C11 11.9199 11.1242 11.621 11.3726 11.3726C11.621 11.1242 11.9199 11 12.2692 11C12.6186 11 12.9175 11.1242 13.1659 11.3726L20 18.2067L26.8341 11.3726C27.0825 11.1242 27.3814 11 27.7307 11C28.0801 11 28.379 11.1242 28.6274 11.3726C28.8758 11.621 29 11.9199 29 12.2692C29 12.6186 28.8758 12.9175 28.6274 13.1659L21.7933 20L28.6274 26.8341C28.8758 27.0825 29 27.3814 29 27.7307C29 28.0801 28.8758 28.379 28.6274 28.6274C28.379 28.8758 28.0801 29 27.7307 29C27.3814 29 27.0825 28.8758 26.8341 28.6274L20 21.7933Z",
    fill: "#4A4D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.75b49c65.svg";
export { ForwardRef as ReactComponent };